import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import {
    AuthService,
    AuthStorageService,
    OAuthLibWrapperService,
    UserAuthEventModule,
    UserAuthModule,
} from '@spartacus/core';
import { OAuthModule, OAuthService, OAuthStorage } from 'angular-oauth2-oidc';
import { VscaAuthService } from './facade/vsca-auth.service';
import { VscaOAuthLibWrapperService } from './service/vsca-oauth-lib-wrapper.service';
import { VscaOAuthService } from './service/vsca-oauth-service';


/**
 * Authentication module for a user. Handlers requests for logged in users,
 * provides authorization services and storage for tokens.
 */
@NgModule({
  imports: [CommonModule, OAuthModule.forRoot(), UserAuthEventModule],
})
export class VscaUserAuthModule extends UserAuthModule {
  static forRoot(): ModuleWithProviders<VscaUserAuthModule> {
    return {
      ngModule: VscaUserAuthModule,
      providers: [
        {
          provide: OAuthStorage,
          useExisting: AuthStorageService,
        },
        {
          provide: OAuthLibWrapperService,
          useExisting: VscaOAuthLibWrapperService,
        },
        {
          provide: OAuthService,
          useExisting: VscaOAuthService,
        },
        {
          provide: AuthService,
          useExisting: VscaAuthService,
        },
      ],
    };
  }
}
